import { sessionStore } from "@redotech/web-util/storage";

export function setSessionStorageWithExpiry(
  key: string,
  value: any,
  numHours = 1,
) {
  const ttl = 60 * 60 * 1000 * numHours;
  const now = new Date();
  const item = { value, expiry: now.getTime() + ttl };
  sessionStore(key).set(JSON.stringify(item));
}

export function getSessionStorageWithExpiry(key: string): any {
  const itemStr = sessionStore(key).get();
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    return null;
  }
  return item.value;
}
